module.exports = (__webpack_require__(6))(214);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-polyfill/lib/index.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 476
// module chunks = 6